import {
	SelectLabel
} from '../../../../../common/components/form/fields';
import { FORM_RULES } from "../../../../../helpers/validations";

const selectStyle = { textAlign: "left", fontSize: "1.6rem", paddingBottom: 20 };

export default (optionsCharts) => [
	{
		component: SelectLabel,
		type: "text",
		name: 'chart',
        placeholder:"Selecione o mapa",
		cols: "12 12 12 12",
		validate: [FORM_RULES.required],
		options: optionsCharts(),
		style: selectStyle,
    }
];
